import type { Customer } from "@store/types";
import { isEqual } from "lodash-es";

export const applyBaseCustomerFields = (target: Customer, source: Customer) => {
    // eslint-disable-next-line no-param-reassign
    target.firstName = source.firstName;
    // eslint-disable-next-line no-param-reassign
    target.lastName = source.lastName;
    // eslint-disable-next-line no-param-reassign
    target.email = source.email;
    // eslint-disable-next-line no-param-reassign
    target.externalId = source.externalId;
    // eslint-disable-next-line no-param-reassign
    target.phoneNumber = source.phoneNumber || "";
    // eslint-disable-next-line no-param-reassign
    target.gender = source.gender || "";
    // eslint-disable-next-line no-param-reassign
    target.dateOfBirth = source.dateOfBirth;
};

export const applyVersionLogic = (target: Customer, source: Customer) => {
    const isNewCustomer = source.id && source.id !== target.id;
    const shouldUpdateVersion =
        !target.version || (source.version && target.version < source.version);

    if (isNewCustomer) {
        // eslint-disable-next-line no-param-reassign
        target.id = source.id;
        // eslint-disable-next-line no-param-reassign
        target.version = source.version;
    }

    if (!isNewCustomer && shouldUpdateVersion) {
        // eslint-disable-next-line no-param-reassign
        target.version = source.version;
    }
};

export const applyAdditionalFields = (target: Customer, source: Customer) => {
    // eslint-disable-next-line no-param-reassign
    target.phoneticFirstName = source.phoneticFirstName || "";
    // eslint-disable-next-line no-param-reassign
    target.phoneticLastName = source.phoneticLastName || "";
    // eslint-disable-next-line no-param-reassign
    (target as any).countryCode = source.phoneCountryCode || "";

    if (!isEqual(target.activeConsentTypes, source.activeConsentTypes)) {
        // eslint-disable-next-line no-param-reassign
        target.activeConsentTypes = source.activeConsentTypes;
    }
};
